<template>
  <div class="footer-box">
    <div class="container">
      <p class="sign"><img style="width:136px" src="../../assets/img/google-img/logo2.png" alt=""></p>
      <div class="line"></div>
      <h1 class="title" v-html="footerInfo.title"></h1>
      <p class="text">{{ footerInfo.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['footerInfo']
}
</script>

<style lang="scss" scoped>
@import '../../style/app.sass';
.footer-box {
  color: #fff;
  background-color: #3C4043;
  >.container {
    display: flex;
    flex-direction: column;
    padding-bottom: 25px;
    .sign {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 18px 0;
    }
    .line {
      height: 1px;
      background-color: #80868A;
    }
    .title {
      font-size: 32px;
      font-weight: 500;
      margin: 30px 0 19px 0;
      @include mobile {
        margin: 15px 0 10px 0;
        font-size: 26px;
      }
    }
    .text {
      font-size: 14px;
      opacity: 0.4;
    }
  }
}
</style>
